var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hiq-news-list"},[_c('h1',{staticClass:"hiq-news-list__heading"},[_vm._v("Nyhetslistning")]),_c('HitList'),_c('Pagination',{attrs:{"results-count":_vm.resultsCount,"results-per-page":_vm.resultsPerPage,"scrollToAtChange":".hiq-news-list__heading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }